import { SvgIcon } from '@mui/material';
import { SMPalette } from '@nx-smartmonkey/ui';

interface GoalCustomerCommunicationProps {
  color?: string;
  style?: React.CSSProperties;
}

export default function GoalCustomerCommunication({
  color = SMPalette.grey1,
  style = {},
}: GoalCustomerCommunicationProps) {
  return (
    <SvgIcon viewBox="0 0 22.34 23.25" style={{ width: `24px`, ...style }}>
      <g>
        <path
          fill={color}
          d="m4.19,17.78h-1.16c-1.63,0-2.95-1.32-2.95-2.95s1.32-2.95,2.95-2.95h1.86l.05.75v5.08l-.75.06Zm-1.16-4.49c-.85,0-1.54.69-1.54,1.54s.69,1.54,1.54,1.54h.5v-3.08h-.5Z"
        />
        <path
          fill={color}
          d="m19.31,17.78h-1.86s-.05-.75-.05-.75v-5.09l.75-.05h1.15c1.63,0,2.95,1.32,2.95,2.95s-1.32,2.95-2.95,2.95Zm-.5-1.41h.5c.85,0,1.54-.69,1.54-1.54s-.69-1.54-1.54-1.54h-.5v3.08Z"
        />
        <path
          fill={color}
          d="m12.24,22.67c-.39,0-.71-.32-.71-.71s.32-.71.71-.71h2.26c2.27-.03,4.12-1.91,4.1-4.19,0-.39.31-.71.7-.71.42.02.71.31.71.7.02,3.06-2.45,5.57-5.51,5.61h-2.27Z"
        />
        <path
          fill={color}
          d="m3.24,12.58h-1.41v-2.5C1.78,4.89,5.97.62,11.17.57c2.53.02,4.89,1.02,6.65,2.82,1.76,1.8,2.72,4.17,2.7,6.69v2.11h-1.41v-2.12c.04-4.43-3.52-8.05-7.94-8.09-4.41.04-7.97,3.67-7.93,8.09v2.51Z"
        />
      </g>
    </SvgIcon>
  );
}
